// src/components/SEO.jsx
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'District Sourcing Tech';
const BASE_URL = 'https://districtsourcingtech.com';

export default function SEO({
  title,
  description = 'DistrictSourcingTech supports government, enterprise and individuals with workforce, managed IT services and training.',
  image = '/og-image.jpg',
  url = BASE_URL,
  type = 'website',
  keywords = 'workforce, managed IT services, government IT, staffing, training, District Sourcing Tech',
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Workforce & Managed IT Services`;

  return (
    <Helmet>
      {/* Primary */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${BASE_URL}${image}`} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${BASE_URL}${image}`} />

      {/* Structured data */}
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": SITE_NAME,
        "url": BASE_URL,
        "logo": `${BASE_URL}/logo.png`,
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-571-758-0720",
          "contactType": "customer service",
          "email": "admin@districtsourcingtech.com"
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "6560 Backlick Rd",
          "addressLocality": "Springfield",
          "addressRegion": "VA",
          "postalCode": "22150",
          "addressCountry": "US"
        },
        "sameAs": [
          "https://www.linkedin.com/company/district-sourcing-tech"
        ]
      })}</script>
    </Helmet>
  );
}
